import React from "react";

export function Field({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-600 block mb-1">{label}</label>
      <input
        type={type}
        data-testid={testid}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
      />
    </div>
  );
}

export function NumberField({ label, value, onChange, step = "0.01", testid }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-600 block mb-1">{label}</label>
      <input
        type="number"
        step={step}
        data-testid={testid}
        value={value ?? 0}
        onChange={(e) => onChange(parseFloat(e.target.value || 0))}
        className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm font-mono"
      />
    </div>
  );
}
